import Resources from '@/scripts/libs/resources'
import wcs from '@/scripts/libs/wcs'

const { trustPilot } = wcs.getStoreConfig()
const trustPilotScriptURl = trustPilot.scriptUrl

export class TrustPilot {
  static loadScript(): void {
    Resources.loadResourcesWithCallback({ resources: [{ src: trustPilotScriptURl }] })
  }

  static formatMoCo(unformattedMoCo: string): string {
    if (!unformattedMoCo) {
      return ''
    }

    const splitMoCo = unformattedMoCo.split('__')

    const firstPartSplitMoCo = splitMoCo[0]
    const firstPartFormattedMoCo = firstPartSplitMoCo + '__'

    const secondPartSplitMoCo = splitMoCo[1]
    const secondPartFormattedMoCo = secondPartSplitMoCo?.replace('_', '/')

    const formattedMoco = firstPartFormattedMoCo + secondPartFormattedMoCo

    return formattedMoco
  }
}
